import PropTypes from "prop-types";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuth from "src/hooks/useAuth";
import { PATH_DASHBOARD } from "src/routes/paths";

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();

  if (!pathname.includes("/aca")) {
    if (isAuthenticated) {
      if (!user.subscriptionName || user.subscriptionName === "") {
        return <Navigate to="/" replace />;
      }
      return <Navigate to={PATH_DASHBOARD.home} replace />;
    }
  }

  return <Outlet />;
}
